import { Header } from "@/components/Header/Header";
import { useNavigate } from "react-router";
import s from "./style.module.scss";
import { Epic } from "@/components/Epic/Epic";
import { Icon24Chevron } from "@vkontakte/icons";
import { UIButton } from "@/components/UIButton/UIButton";
import { logout } from "@/core/api/requests/logout";
import { userAtom } from "@/core/reatom/state/user/user";
import { useAtom } from "@reatom/npm-react";
import { UserLine } from "@/components/UserLine/UserLine";
import { initDataUser } from "@telegram-apps/sdk-react";
import { Auth } from "@/components/Auth/Auth";
import { SpinLoader } from "@/components/SpinLoader/SpinLoader";
import { Block } from "@/components/Block/Block";
import Notification from "@/assets/notification.svg?react";
import Theme from "@/assets/theme.svg?react";
import { Switch } from "@vkontakte/vkui";
import clsx from "clsx";

export const ProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useAtom(userAtom);
  const data = initDataUser();
  return (
    <div className={clsx(s.wrapper, user !== 1 && s.bg)}>
      <Header title="Профиль" />

      {user === 1 && (
        <div className={s.innerWrapper}>
          <Block borderRadius="bottom" className={s.header}>
            <hr className={s.separator} />
            <div className={s.userInfo}>
              <UserLine
                name={data?.username}
                photo_url={data?.photo_url}
                isLoading={!data?.id}
              />{" "}
              <button
                onClick={() => navigate("/orders")}
                className={s.ordersButton}
              >
                <div className={s.ordersWrapper}>
                  <p className={s.ordersTitle}>Заказы</p>
                  <p className={s.ordersDescr}>Текущие и закрытые</p>
                </div>
                <Icon24Chevron className={s.icon} />
              </button>
            </div>
          </Block>
          <Block borderRadius="top" className={s.secondBlock}>
            {/* <div className={s.settingsWrapper}>
              <p className={s.ordersTitle}>Настройки</p>

              <div className={s.settings}>
                <Theme />
                <p className={s.settingsText}>Тема</p>
                <div className={s.theme}>
                  <p className={s.themeText}>Светлая</p>

                  <Icon24Chevron className={s.icon} />
                </div>
              </div>
              <hr className={s.separator} />

              <div className={s.settings}>
                <Notification />
                <p className={s.settingsText}>Уведомления</p>
                <Switch className={s.switcher} />
              </div>
            </div> */}
            <div />
            <UIButton
              className={s.button}
              fontType={"primary-2"}
              color={"inverted"}
              size="normal"
              onClick={() => logout().then(() => setUser(null))}
            >
              Выйти из профиля
            </UIButton>
          </Block>
        </div>
      )}
      {user === 0 && <Auth />}
      {user === null && <SpinLoader />}
      <Epic />
    </div>
  );
};
